import { InstructionJsonbBlock } from '@components/BlockNote/types';
import { ROLE } from '@containers/app/types';
import { DUPLICATE_FLOW_ERROR, FLOW_DELETION_ERROR } from '@utils/data/enums';

export const options = [
  { value: 'addNewProject', label: 'Add a new project' },
  {
    label: 'Switch to project',
    options: [
      {
        value: 'project1',
        label: 'Global Tech Innovators Exam - TSF',
        details: { id: '#878902', location: 'India' },
        disabled: false,
      },
      {
        value: 'project2',
        label: 'MBA Entrance Series - North American University',
        details: { id: '#878903', location: 'India' },
        disabled: false,
      },
      {
        value: 'project3',
        label: 'European Art History Assessment',
        details: { id: '#878904', location: 'India' },
        disabled: false,
      },
      {
        value: 'project4',
        label: 'Asia-Pacific Leadership Program Test - One European Art History, socio economic culture in middle ages',
        details: { id: '#878905', location: 'India' },
        disabled: false,
      },
    ],
  },
  {
    label: 'DEACTIVATED',
    options: [
      {
        value: 'project4',
        label: 'Asia-Pacific Leadership Program Test',
        details: { id: '#878905', location: 'India' },
        disabled: true,
      },
      {
        value: 'project5',
        label: 'Asia-Pacific Leadership Program Test-1',
        details: { id: '#878906', location: 'India' },
        disabled: true,
      },
    ],
  },
];

export const currentProject = {
  id: '1',
  name: 'Test Project',
  region: 'us-west-2',
  flows: [
    {
      id: '1',
      name: 'Test Flow',
    },
  ],
  token: '0aa11586-9771-4988-8112-3ccce32a46fe',
};

export const currentProjectWithOutFlows = {
  id: '1',
  name: 'Test Project',
  region: 'us-west-2',
  flows: [],
  token: '0aa11586-9771-4988-8112-3ccce32a46fe',
};

export const currentProjectsInitialState = {
  id: '',
  name: '',
  region: '',
  description: '',
  flows: [],
  token: '',
};

export const newProjectsInitialState = {
  id: '',
  name: '',
  region: '',
  description: '',
  flows: [],
  token: '',
};

export const flowInitialState = {
  isLoading: false,
  error: '',
  uuid: '',
};

export const flowSuccessState = {
  uuid: '123-123-123',
  isLoading: false,
  error: '',
};

export const flowErrorState = {
  uuid: '',
  isLoading: false,
  error: 'error creating flow',
};

export const flowDuplicateErrorState = {
  uuid: '',
  isLoading: false,
  error: DUPLICATE_FLOW_ERROR,
};

export const deleteFlowErrorState = {
  uuid: '',
  isLoading: false,
  error: FLOW_DELETION_ERROR,
};

export const mockTemplateList = [
  {
    id: '1',
    name: 'Template 1',
    project_id: '10',
    is_template: true,
  },
  {
    id: '2',
    name: 'Template 2',
    is_template: true,
    project_id: '10',
  },
];

export const duplicateFlowErrorState = {
  uuid: '',
  isLoading: false,
  error: 'Uniqueness violation. duplicate key value violates unique constraint "idx_flow_project_id_name"',
};

export const mockProjects = [
  {
    id: '1',
    name: 'TEST PROJECT',
    region: 'AUSTRALIA',
    tags: [
      {
        id: 1,
        key: 'env',
        value: 'staging',
      },
    ],
    flows: [
      {
        id: '1',
        name: 'FLOW 1',
      },
      {
        id: '2',
        name: 'FLOW 2',
      },
    ],
    token: '0aa11586-9771-4988-8112-3ccce32a46fe',
  },
  {
    id: '2',
    name: 'TEST PROJECT 2',
    region: 'EUROPE',
    tags: [
      {
        id: 1,
        key: 'isProd',
        value: 'false',
      },
    ],
    flows: [],
    token: '0aa11586-9771-4988-8112-3ccce32a46fe',
  },
];

export const mockBlackListApps = {
  mac: [
    'Anydesk',
    'Teamviewer',
    'Firefox',
    'Chrome',
    'Opera',
    'Safari',
    'Teams',
    'Slack',
    'Skype',
    'Facetime',
    'Brave',
    'Zoom',
  ],
  windows: [
    'Anydesk',
    'Teamviewer',
    'Firefox',
    'Chrome',
    'Opera',
    'Safari',
    'Edge',
    'Webex',
    'Riot',
    'Seamonkey',
    'Teams',
    'G2M',
    'Zoom',
    'Element',
    'Slack',
    'Camtasia',
    'Camrecorder',
    'Camplay',
    'Discord',
    'Skype',
    'Join Me',
    'RPC Suite',
    'Remote',
    'Beam your screen',
    'Aero',
    'VNC',
    'Gotomeeting',
    'Ammy admin.',
  ],
};

export const mockUser = {
  currentRole: ROLE.TENANT_ADMIN,
  accountName: '',
  isLoggedIn: true,
  email: 'john.doe@example.com',
  uid: 'rSTR5v031daNRLHOoXaloDp7sK00',
  name: 'John Doe',
  username: 'john.doe@example.com',
  id: 1,
  tenant: {
    id: 69,
    name: 'Example',
    subdomain: 'Example',
  },
  roles: [],
  metadata: {
    createdAt: '1716873227909',
    creationTime: 'Tue, 28 May 2024 05:13:47 GMT',
    lastLoginAt: '1721818882951',
    lastSignInTime: 'Wed, 24 Jul 2024 11:01:22 GMT',
  },
  url: '',
};

export const mockPrivileges = {
  Events: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  Exams: { canView: true, canCreate: true, canDelete: true, canEdit: true },
  Payments: { canView: true, canCreate: true, canDelete: true, canEdit: true },
  Settings: { canView: true, canCreate: true, canDelete: true, canEdit: true },
  Projects: { canView: true, canCreate: true, canDelete: true, canEdit: true },
  Flows: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  Help: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  Home: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  Notifications: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  Proctors: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  Profile: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  FinancialReport: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  Rooms: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  Schedule: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  Sessions: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
  Vouchers: {
    canCreate: true,
    canDelete: true,
    canEdit: true,
    canView: true,
  },
};

export const userData = [
  {
    displayName: null,
    roles: [],
    currentRole: 'TENANT_ADMIN',
    accountName: '',
    organization: 69,
    isLoggedIn: true,
    email: 'sandeep.hm+69@talview.com',
    uid: 'rSTR5v031daNRLHOoXaloDp7sKI2',
    id: 67405,
    metadata: {
      createdAt: '1716873227909',
      lastLoginAt: '1727763563857',
      creationTime: 'string;',
      lastSignInTime: 'string;',
    },
    name: 'Sandeep',
    username: 'sandeep.hm+69@talview.com',
    old_id: null,
    tenant: {
      name: 'company 2 -Pvt. Ltd',
      id: 69,
      subdomain: '',
    },
    phone_number: '',
    profile_pic_file_id: 19216,
    url: '',
  },
  {
    displayName: null,
    roles: [],
    currentRole: 'TENANT_ADMIN',
    accountName: '',
    organization: 69,
    isLoggedIn: true,
    email: 'sandeep.hm+69@talview.com',
    uid: 'rSTR5v031daNRLHOoXaloDp7sKI2',
    id: 67405,
    metadata: {
      createdAt: '1716873227909',
      lastLoginAt: '1727763563857',
      creationTime: 'string;',
      lastSignInTime: 'string;',
    },
    name: 'Sandeep',
    username: 'sandeep.hm+69@talview.com',
    old_id: null,
    tenant: {
      name: 'company 2 -Pvt. Ltd',
      id: 69,
      subdomain: '',
    },
    profile_pic_file_id: 19216,
    url: '',
  },
  {
    displayName: null,
    roles: [],
    currentRole: 'TENANT_ADMIN',
    accountName: '',
    organization: 69,
    isLoggedIn: true,
    email: 'sandeep.hm+69@talview.com',
    uid: 'rSTR5v031daNRLHOoXaloDp7sKI2',
    id: 67405,
    metadata: {
      createdAt: '1716873227909',
      lastLoginAt: '1727763563857',
      creationTime: 'string;',
      lastSignInTime: 'string;',
    },
    name: 'Sandeep',
    username: 'sandeep.hm+69@talview.com',
    old_id: null,
    tenant: {
      name: 'company 2 -Pvt. Ltd',
      id: 69,
      subdomain: '',
    },
    profile_pic_file_id: 19216,
    url: '',
  },
  {
    displayName: null,
    roles: [],
    currentRole: 'TENANT_ADMIN',
    accountName: '',
    organization: 69,
    isLoggedIn: true,
    email: 'sandeep.hm+69@talview.com',
    uid: 'rSTR5v031daNRLHOoXaloDp7sKI2',
    id: 67405,
    metadata: {
      createdAt: '1716873227909',
      lastLoginAt: '1727763563857',
      creationTime: 'string;',
      lastSignInTime: 'string;',
    },
    name: 'Sandeep',
    username: 'sandeep.hm+69@talview.com',
    old_id: null,
    tenant: {
      name: 'company 2 -Pvt. Ltd',
      id: 69,
      subdomain: '',
    },
    profile_pic_file_id: 19216,
    url: '',
  },
  {
    displayName: null,
    roles: [],
    currentRole: 'TENANT_ADMIN',
    accountName: '',
    organization: 69,
    isLoggedIn: true,
    email: 'sandeep.hm+69@talview.com',
    uid: 'rSTR5v031daNRLHOoXaloDp7sKI2',
    id: 67405,
    metadata: {
      createdAt: '1716873227909',
      lastLoginAt: '1727763563857',
      creationTime: 'string;',
      lastSignInTime: 'string;',
    },
    name: 'Sandeep',
    username: 'sandeep.hm+69@talview.com',
    old_id: null,
    tenant: {
      name: 'company 2 -Pvt. Ltd',
      id: 69,
      subdomain: '',
    },
    profile_pic_file_id: 19216,
    url: '',
  },
  {
    displayName: null,
    roles: [],
    currentRole: 'TENANT_ADMIN',
    accountName: '',
    organization: 69,
    isLoggedIn: true,
    email: 'sandeep.hm+69@talview.com',
    uid: 'rSTR5v031daNRLHOoXaloDp7sKI2',
    id: 67405,
    metadata: {
      createdAt: '1716873227909',
      lastLoginAt: '1727763563857',
      creationTime: 'string;',
      lastSignInTime: 'string;',
    },
    name: 'Sandeep',
    username: 'sandeep.hm+69@talview.com',
    old_id: null,
    tenant: {
      name: 'company 2 -Pvt. Ltd',
      id: 69,
      subdomain: '',
    },
    profile_pic_file_id: 19216,
    url: '',
  },
  {
    displayName: null,
    roles: [],
    currentRole: 'TENANT_ADMIN',
    accountName: '',
    organization: 69,
    isLoggedIn: true,
    email: 'sandeep.hm+69@talview.com',
    uid: 'rSTR5v031daNRLHOoXaloDp7sKI2',
    id: 67405,
    metadata: {
      createdAt: '1716873227909',
      lastLoginAt: '1727763563857',
      creationTime: 'string;',
      lastSignInTime: 'string;',
    },
    name: 'Sandeep',
    username: 'sandeep.hm+69@talview.com',
    old_id: null,
    tenant: {
      name: 'company 2 -Pvt. Ltd',
      id: 69,
      subdomain: '',
    },
    profile_pic_file_id: 19216,
    url: '',
  },
  {
    displayName: null,
    roles: [],
    currentRole: 'TENANT_ADMIN',
    accountName: '',
    organization: 69,
    isLoggedIn: true,
    email: 'sandeep.hm+69@talview.com',
    uid: 'rSTR5v031daNRLHOoXaloDp7sKI2',
    id: 67405,
    metadata: {
      createdAt: '1716873227909',
      lastLoginAt: '1727763563857',
      creationTime: 'string;',
      lastSignInTime: 'string;',
    },
    name: 'Sandeep',
    username: 'sandeep.hm+69@talview.com',
    old_id: null,
    tenant: {
      name: 'company 2 -Pvt. Ltd',
      id: 69,
      subdomain: '',
    },
    profile_pic_file_id: 19216,
    url: '',
  },
];

export const mockProctorData = [
  {
    email: 'test+1@test.com',
    id: 85824,
    name: 'test1',
  },
];

export const candidateOptions = [
  { label: 'candidate_one', value: 'First Candidate' },
  { label: 'candidate_two', value: 'Second Candidate' },
];

export const disabledOptions = [
  { label: 'disabled_one', value: 'First Disabled' },
  { label: 'disabled_two', value: 'Second Disabled' },
];

export const concentrationOptions = [
  { label: 'concentration_one', value: 'First toys' },
  { label: 'concentration_two', value: 'Second toys' },
];

export const lensOptions = [
  { label: 'lens_one', value: 'First lens' },
  { label: 'lens_two', value: 'Second lens' },
  { label: 'lens_one', value: 'First lens' },
  { label: 'lens_two', value: 'Second lens' },
  { label: 'lens_one', value: 'First lens' },
  { label: 'lens_two', value: 'Second lens' },
  { label: 'lens_one', value: 'First lens' },
  { label: 'lens_two', value: 'Second lens' },
  { label: 'lens_one', value: 'First lens' },
  { label: 'lens_two', value: 'Second lens' },
];

export const otherOptions = [
  { label: 'other_one', value: 'First other' },
  { label: 'other_two', value: 'Second other' },
  { label: 'other_three', value: 'Third other' },
  { label: 'other_four', value: 'Fourth other' },
];

export const flowOptions = [
  { label: 'Flow 1', value: 'flow1' },
  { label: 'Flow 2', value: 'flow2' },
  { label: 'Flow 3', value: 'flow3' },
  { label: 'Flow 4', value: 'flow4' },
  { label: 'Flow 5', value: 'flow5' },
  { label: 'Flow 6', value: 'flow6' },
];

export const attendeeList = [
  {
    label: 'Attendee 1',
    value: 'Attendee 1',
  },
  {
    label: 'Attendee 2',
    value: 'Attendee 2',
  },
];

export const blockNoteInstructions: InstructionJsonbBlock = {
  doc: [
    {
      id: '1',
      type: 'heading',
      props: { textAlignment: 'center', level: 2 },
      content: [
        {
          type: 'text',
          text: 'Proctor ',
          styles: { bold: true },
        },
        {
          type: 'text',
          text: 'Instructions',
          styles: { bold: true, textColor: 'blue' },
        },
      ],
      children: [],
    },
    {
      id: '2',
      type: 'paragraph',
      props: { textAlignment: 'left' },
      content: [
        {
          type: 'text',
          text: 'Please read the following ',
          styles: { italic: true },
        },
        {
          type: 'text',
          text: 'guidelines carefully before proceeding.',
          styles: { underline: true },
        },
      ],
      children: [],
    },
    {
      id: '3',
      type: 'bulletListItem',
      props: { textAlignment: 'left' },
      content: [
        {
          type: 'text',
          text: 'Verify student identity against provided',
          styles: { bold: true },
        },
        {
          type: 'text',
          text: 'photo ID.',
          styles: { italic: true },
        },
      ],
      children: [],
    },
    {
      id: '5',
      type: 'numberedListItem',
      props: { textAlignment: 'left' },
      content: [
        {
          type: 'text',
          text: 'Review your ',
          styles: { bold: true },
        },
        {
          type: 'text',
          text: 'details',
          styles: { italic: true, textColor: 'green' },
        },
      ],
      children: [],
    },
    {
      id: '6',
      type: 'numberedListItem',
      props: { textAlignment: 'left' },
      content: [
        {
          type: 'text',
          text: 'Test ID: ',
          styles: { textColor: 'default' },
        },
        {
          type: 'text',
          text: 'Confirm the test ID',
          styles: { bold: true, underline: true },
        },
      ],
      children: [],
    },
    {
      id: '7',
      type: 'paragraph',
      props: { textAlignment: 'center' },
      content: [
        {
          type: 'text',
          text: 'Thank you ',
          styles: { bold: true },
        },
        {
          type: 'text',
          text: 'for your cooperation!',
          styles: { italic: true, textColor: 'blue' },
        },
      ],
      children: [],
    },

    {
      id: '8',
      type: 'paragraph',
      props: {},
      content: [
        {
          type: 'text',
          text: 'Sample text',
          styles: {},
        },
      ],
      children: [],
    },
    {
      id: '5c3aa26a-9d59-469e-9660-b56e09d995fc',
      type: 'paragraph',
      props: {
        textColor: 'default',
        textAlignment: 'left',
        backgroundColor: 'default',
      },
      content: [
        {
          text: 'Test ID: ',
          type: 'text',
          styles: {},
        },
        {
          text: '60000000127',
          type: 'text',
          styles: {
            bold: true,
          },
        },
      ],
      children: [],
    },
    {
      id: '7977385e-55b5-4691-b226-2a39fd0fef97',
      type: 'paragraph',
      props: {
        textColor: 'default',
        textAlignment: 'left',
        backgroundColor: 'default',
      },
      content: [
        {
          text: 'Ensure environment scan is complete and thorough.',
          type: 'text',
          styles: {},
        },
      ],
      children: [
        {
          id: '1713ca3c-9be7-47db-ba50-1073e63d421a',
          type: 'bulletListItem',
          props: {
            textColor: 'default',
            textAlignment: 'left',
            backgroundColor: 'default',
          },
          content: [
            {
              text: 'Test :',
              type: 'text',
              styles: {},
            },
            {
              text: 'Be available for technical assistance',
              type: 'text',
              styles: {
                bold: true,
              },
            },
          ],
          children: [],
        },
        {
          id: 'a7af9ec8-8b57-47d7-8b60-52b6e4cef9b5',
          type: 'bulletListItem',
          props: {
            textColor: 'default',
            textAlignment: 'left',
            backgroundColor: 'default',
          },
          content: [
            {
              text: 'Test: ',
              type: 'text',
              styles: {},
            },
            {
              text: 'Unusual typing patterns',
              type: 'text',
              styles: {
                bold: true,
              },
            },
          ],
          children: [],
        },
      ],
    },
    {
      id: '3db1d951-e80d-40fc-b6ce-a80e7f421d84',
      type: 'table',
      props: {
        textColor: 'default',
      },
      content: {
        type: 'tableContent',
        rows: [
          {
            cells: [
              {
                type: 'tableCell',
                content: [
                  {
                    type: 'text',
                    text: 'test1',
                    styles: {},
                  },
                ],
                props: {
                  backgroundColor: 'default',
                  textColor: 'default',
                  textAlignment: 'left',
                },
              },
              {
                type: 'tableCell',
                content: [
                  {
                    type: 'text',
                    text: 'test2',
                    styles: {},
                  },
                ],
                props: {
                  backgroundColor: 'default',
                  textColor: 'default',
                  textAlignment: 'left',
                },
              },
              {
                type: 'tableCell',
                content: [
                  {
                    type: 'text',
                    text: 'test3',
                    styles: {},
                  },
                ],
                props: {
                  backgroundColor: 'default',
                  textColor: 'default',
                  textAlignment: 'left',
                },
              },
            ],
          },
          {
            cells: [
              {
                type: 'tableCell',
                content: [
                  {
                    type: 'text',
                    text: '1',
                    styles: {},
                  },
                ],
                props: {
                  backgroundColor: 'default',
                  textColor: 'default',
                  textAlignment: 'left',
                },
              },
              {
                type: 'tableCell',
                content: [
                  {
                    type: 'text',
                    text: '2',
                    styles: {},
                  },
                ],
                props: {
                  backgroundColor: 'default',
                  textColor: 'default',
                  textAlignment: 'left',
                },
              },
              {
                type: 'tableCell',
                content: [
                  {
                    type: 'text',
                    text: '3',
                    styles: {},
                  },
                ],
                props: {
                  backgroundColor: 'default',
                  textColor: 'default',
                  textAlignment: 'left',
                },
              },
            ],
          },
        ],
      },
      children: [],
    },
    {
      id: 'f1a2b9f3-6d4b-4c1c-bb8d-0e7a2c3f4b4f',
      type: 'image',
      props: {
        textColor: 'default',
        textAlignment: 'left',
        backgroundColor: 'default',
        caption: 'Image caption',
        url: 'https://i0.wp.com/civillane.com/wp-content/uploads/2017/12/avatar.jpg?ssl=1',
        previewWidth: 100,
      },
      children: [],
    },
  ],
};

export const transactionData = [
  {
    id: 'txn_001',
    drive_occurrence_guest_id: 'guest_123',
    created_by_details: {
      email: 'john.doe@example.com',
      name: 'John Doe',
    },
    workflow: {
      name: 'Proview Test Course',
      id: 101,
    },
    transaction_action: 'Scheduling',
    transaction_date: '2023-10-01T14:30:00Z',
    status: 'Completed',
    sku_value: 249.99,
    discount_percentage: '10',
    code: 'SAVE10',
    currency: 'USD',
    tax_charged: '15.00',
    tax_rate: 6,
    tax_type: 'GST',
    conversion_rate: 1.0,
    nationality: 'US',
    invoice: {
      id: 'inv_001',
    },
  },
  {
    id: 'txn_002',
    drive_occurrence_guest_id: 45678,
    created_by_details: {
      email: 'jane.smith@example.com',
      name: 'Jane Smith',
    },
    workflow: {
      name: 'Proview Test Course',
      id: 102,
    },
    transaction_action: 'Scheduling',
    transaction_date: '2023-10-02T10:00:00Z',
    status: 'Pending',
    sku_value: 500.0,
    discount_percentage: '0',
    code: '',
    currency: 'USD',
    tax_charged: '0.00',
    tax_rate: 0,
    tax_type: 'GST',
    conversion_rate: 1.0,
    nationality: 'US',
    invoice: {
      id: 'inv_002',
    },
  },
  {
    id: 'txn_003',
    drive_occurrence_guest_id: 'guest_789',
    created_by_details: {
      email: 'alice.johnson@example.com',
      name: 'Alice Johnson',
    },
    workflow: {
      name: 'Proview mock',
      id: 103,
    },
    transaction_action: 'Scheduling',
    transaction_date: '2023-10-03T09:15:00Z',
    status: 'Completed',
    sku_value: 79.99,
    discount_percentage: '5',
    code: 'FALL5',
    currency: 'USD',
    tax_charged: '4.80',
    tax_rate: 6,
    tax_type: 'GST',
    conversion_rate: 1.0,
    nationality: 'US',
    invoice: {
      id: 'inv_003',
    },
  },
];
